import { render, staticRenderFns } from "./nzgys.vue?vue&type=template&id=2895a605&scoped=true"
import script from "./nzgys.vue?vue&type=script&lang=js"
export * from "./nzgys.vue?vue&type=script&lang=js"
import style0 from "./nzgys.vue?vue&type=style&index=0&id=2895a605&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2895a605",
  null
  
)

export default component.exports